export default __webpack_public_path__ + "static/media/830.b0aeb316.gif";